import { Box, Typography } from '@mui/material';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getActiveTicket } from 'store/ticket-service/selector';
import { ITicketChange } from 'store/ticket-service/types';

import { HistoryActionTypes, NamespacesList } from 'core/enums/common';

import { TicketUpdateTime } from 'components/shared/ticketUpdateTime';

import { NotificationsChangesDisplayBlock } from './changesDisplay/NotificationsChangesDisplayBlock';
import { UseCasesChangesDisplay } from './changesDisplay/UseCasesChangesDisplay';
import { UserStoriesChangesDisplay } from './changesDisplay/UserStoriesChangesDisplay';
import { UserTestCasesChangesDisplay } from './changesDisplay/UserTestCasesChangesDisplay';

interface IDetailedChangesProps {
	currentHistoryItem: ITicketChange | null;
}

export const DetailedChangesView: FC<IDetailedChangesProps> = ({ currentHistoryItem }) => {
	const { t: commonTranslate } = useTranslation(NamespacesList['common']);

	const activeTicket = useSelector(getActiveTicket);

	const currentHistoryItemDisplayBlock = useMemo(() => {
		if (currentHistoryItem?.oldValue && currentHistoryItem?.newValue) {
			const oldValue = JSON.parse(currentHistoryItem.oldValue);

			const newValue = JSON.parse(currentHistoryItem.newValue);

			switch (currentHistoryItem?.actionHistoryEnum) {
				case HistoryActionTypes.userStoriesEdit:
					return <UserStoriesChangesDisplay oldValue={oldValue} newValue={newValue} />;
				case HistoryActionTypes.useCasesEdit:
					return <UseCasesChangesDisplay oldValue={oldValue} newValue={newValue} />;
				case HistoryActionTypes.notificationsEdit:
					return <NotificationsChangesDisplayBlock oldValue={oldValue} newValue={newValue} />;
				case HistoryActionTypes.testCasesEdit:
					return <UserTestCasesChangesDisplay oldValue={oldValue} newValue={newValue} />;
				default:
					return null;
			}
		} else {
			return null;
		}
	}, [currentHistoryItem]);

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				height: '100%',
				gap: '16px',
			}}
		>
			<Box>
				<Typography
					sx={{
						fontSize: '24px',
						'@media (max-width: 1536px)': {
							fontSize: '18px',
						},
						fontWeight: '700',
						whiteSpace: { xs: 'wrap', md: 'nowrap' },
						textOverflow: 'ellipsis',
						overflow: 'hidden',
						maxWidth: '600px',
					}}
				>
					{activeTicket?.title === 'text.defaultTicketTitle' ||
					activeTicket?.title === 'New request'
						? commonTranslate(activeTicket.title)
						: activeTicket?.title || ''}
				</Typography>
				<TicketUpdateTime
					createDate={activeTicket?.createdDate}
					updateDate={activeTicket?.updatedDate}
				/>
			</Box>
			{currentHistoryItem ? currentHistoryItemDisplayBlock : null}
		</Box>
	);
};
